/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Average_Per_MinuteInputs */



/**
* | output |
* | --- |
* | "Average per minute" |
*
* @param {Consumption_Average_Per_MinuteInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_average_per_minute = /** @type {((inputs?: Consumption_Average_Per_MinuteInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Average_Per_MinuteInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Average per minute")
	return /** @type {LocalizedString} */ ("Moyenne par minute")
});